import React from 'react'
import { Helmet } from 'react-helmet'

import { isProduction } from '@common-sense-privacy/common'

import { Props } from './types'

function ScreenWrapper({
  children,
  meta,
  metaDescription = '',
  metaKeywords = '',
  styles,
  title = 'Common Sense Privacy',
}: Props): React.ReactElement {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name='description' content={metaDescription} />
        <meta name='keywords' content={metaKeywords} />
        {!isProduction && <meta name='robots' content='noindex, nofollow' />}

        {meta}

        {styles && <style type='text/css'>{styles}</style>}
      </Helmet>
      {children}
    </>
  )
}

export default ScreenWrapper
